import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { ProductOriginAction } from '../actions/productOriginsActions'
import { GET_PRODUCTORIGINS_EXITO } from '../types/productOriginsTypes'

export interface ProductOriginsState {
  productOriginsState: {
    productOrigins?: ProductOrigin[]
    error?: string | undefined
  }
}

const initialState: ProductOriginsState = {
  productOriginsState: { productOrigins: [], error: '' }
}

export const productOriginsReducer = (
  state: ProductOriginsState = initialState,
  action: ProductOriginAction
): ProductOriginsState => {
  if (action.type === GET_PRODUCTORIGINS_EXITO) {
    return {
      ...state,
      productOriginsState: {
        productOrigins: action.productOrigins,
        error: action.error
      }
    }
  }
  return state
}
